(function () {
  function initCarousel(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-track]');
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const count = root.querySelector('[data-count]');
    if (!track || !slides.length) return;
    let index = 0;
    function update() {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.classList.toggle('is-next', i === index + 1);
        slide.style.setProperty('--slide-offset', String(i - index));
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      if (count) count.textContent = (index + 1) + ' of ' + slides.length;
    }
    if (prev) prev.addEventListener('click', function () { index = Math.max(0, index - 1); update(); });
    if (next) next.addEventListener('click', function () { index = Math.min(slides.length - 1, index + 1); update(); });
    let startX = null;
    track.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (event) {
      if (startX === null) return;
      const delta = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(delta) > 45) { index = Math.max(0, Math.min(slides.length - 1, index + (delta < 0 ? 1 : -1))); update(); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initExplorer(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const stage = root.querySelector('.ccv4-explorer__stage');
    const hotspots = Array.from(root.querySelectorAll('[data-hotspot]'));
    const cards = Array.from(root.querySelectorAll('[data-card]'));
    const cardsById = new Map(cards.map(function (card) { return [card.dataset.card, card]; }));
    const cardLayer = document.createElement('div');
    cardLayer.className = 'ccv4-card-layer';
    cardLayer.dataset.owner = root.id || 'co-create-explorer';
    cards.forEach(function (card) { cardLayer.appendChild(card); });
    document.body.appendChild(cardLayer);
    const sheetMode = window.matchMedia('(max-width: 640px)');
    const hoverMode = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 641px)');
    let closeTimer = null;

    function cancelScheduledClose() {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    function scheduleClose() {
      cancelScheduledClose();
      closeTimer = window.setTimeout(closeAll, 180);
    }

    function syncInputMode() {
      root.classList.toggle('is-mobile-drawer', sheetMode.matches);
    }
    syncInputMode();
    const hideTimers = new WeakMap();

    function closeAll() {
      cancelScheduledClose();
      cards.forEach(function (card) {
        card.classList.remove('is-open');
        const oldTimer = hideTimers.get(card);
        if (oldTimer) window.clearTimeout(oldTimer);
        hideTimers.set(card, window.setTimeout(function () { card.hidden = true; }, 330));
      });
      hotspots.forEach(function (spot) { spot.classList.remove('is-active'); });
      stage.classList.remove('is-spotlit');
    }

    function openCard(spot, card) {
      cancelScheduledClose();
      cards.forEach(function (item) {
        if (item !== card) {
          item.classList.remove('is-open');
          const oldTimer = hideTimers.get(item);
          if (oldTimer) window.clearTimeout(oldTimer);
          hideTimers.set(item, window.setTimeout(function () { item.hidden = true; }, 330));
        }
      });
      hotspots.forEach(function (item) { item.classList.toggle('is-active', item === spot); });
      const cardTimer = hideTimers.get(card);
      if (cardTimer) window.clearTimeout(cardTimer);
      card.hidden = false;
      stage.style.setProperty('--spot-x', spot.style.getPropertyValue('--x'));
      stage.style.setProperty('--spot-y', spot.style.getPropertyValue('--y'));
      stage.style.setProperty('--spot-w', spot.style.getPropertyValue('--spot-w'));
      stage.style.setProperty('--spot-h', spot.style.getPropertyValue('--spot-h'));
      stage.classList.add('is-spotlit');
      if (!sheetMode.matches) {
        const rect = spot.getBoundingClientRect();
        const width = card.offsetWidth;
        const height = card.offsetHeight;
        card.style.left = Math.max(12, Math.min(window.innerWidth - width - 12, rect.left + rect.width / 2 - width / 2)) + 'px';
        card.style.top = Math.max(12, rect.top - height - 24) + 'px';
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { card.classList.add('is-open'); });
      });
    }

    hotspots.forEach(function (spot) {
      const card = cardsById.get(spot.dataset.hotspot);
      if (!card) return;

      spot.addEventListener('mouseenter', function () {
        if (hoverMode.matches) openCard(spot, card);
      });
      spot.addEventListener('mouseleave', function () {
        if (hoverMode.matches) scheduleClose();
      });
      spot.addEventListener('focus', function () {
        if (hoverMode.matches) openCard(spot, card);
      });
      spot.addEventListener('blur', function () {
        if (hoverMode.matches) scheduleClose();
      });
      card.addEventListener('mouseenter', function () {
        if (hoverMode.matches) cancelScheduledClose();
      });
      card.addEventListener('mouseleave', function () {
        if (hoverMode.matches) scheduleClose();
      });

      spot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (hoverMode.matches) return;
        const wasOpen = spot.classList.contains('is-active');
        if (wasOpen) closeAll();
        else openCard(spot, card);
      });

      const close = card.querySelector('[data-close]');
      if (close) close.addEventListener('click', function () { closeAll(); });
      card.querySelectorAll('[data-option]').forEach(function (option) {
        option.addEventListener('click', function () {
          card.querySelectorAll('[data-option]').forEach(function (item) { item.classList.remove('is-active'); });
          option.classList.add('is-active');
          const container = card.querySelector('[data-preview-container]');
          if (container && option.dataset.image) {
            let preview = container.querySelector('[data-preview]');
            if (!preview) {
              container.innerHTML = '';
              preview = document.createElement('img');
              preview.dataset.preview = '';
              preview.alt = '';
              preview.width = 800;
              preview.height = 800;
              container.appendChild(preview);
            }
            preview.classList.remove('is-loaded');
            const nextImage = new Image();
            nextImage.onload = function () {
              preview.src = option.dataset.image;
              window.requestAnimationFrame(function () { preview.classList.add('is-loaded'); });
            };
            nextImage.src = option.dataset.image;
          }
        });
      });
    });
    stage.addEventListener('click', closeAll);
    document.addEventListener('click', function (event) {
      const activeSpot = root.querySelector('.ccv4-hotspot.is-active');
      if (!activeSpot) return;
      const activeCard = cardsById.get(activeSpot.dataset.hotspot);
      if (activeSpot.contains(event.target) || (activeCard && activeCard.contains(event.target))) return;
      closeAll();
    });
    document.addEventListener('scroll', function () {
      if (!sheetMode.matches && root.querySelector('.ccv4-hotspot.is-active')) closeAll();
    }, { passive: true, capture: true });
    window.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeAll(); });
    window.addEventListener('resize', function () {
      syncInputMode();
      const active = root.querySelector('.ccv4-hotspot.is-active');
      if (!active) return;
      const card = cardsById.get(active.dataset.hotspot);
      if (!card) return;
      if (sheetMode.matches) {
        card.style.left = '';
        card.style.top = '';
      } else {
        const rect = active.getBoundingClientRect();
        const width = card.offsetWidth;
        const height = card.offsetHeight;
        card.style.left = Math.max(12, Math.min(window.innerWidth - width - 12, rect.left + rect.width / 2 - width / 2)) + 'px';
        card.style.top = Math.max(12, rect.top - height - 24) + 'px';
      }
    });
  }

  function initWorks(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-works-track]');
    const prev = root.querySelector('[data-works-prev]');
    const next = root.querySelector('[data-works-next]');
    if (!track || !prev || !next) return;
    function step() { const card = track.querySelector('.ccv4-work'); return card ? card.getBoundingClientRect().width + 20 : track.clientWidth; }
    function update() { const max = track.scrollWidth - track.clientWidth; prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max - 2; }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ccv4-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-ccv4-explorer]').forEach(initExplorer);
    (scope || document).querySelectorAll('[data-ccv4-works]').forEach(initWorks);
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
